/**
 * Example useage can be found here backbone/test/jasmine/specs/InterpolatingUtil.spec.js
 */
const InterpolatingUtil = {
    /**
     * https://confluence.garmin.com/display/DI/AAE+-+Interpolating+Missing+Data+Points
     *
     * @param {*} a
     * @param {*} b
     * @param {*} a1
     * @param {*} b1
     * @param {*} x
     */
    linearInterpolating(a, b, a1, b1, x) {
        let y = ((b1 - b) / (a1 - a)) * (x - a1) + b1;
        return y;
    },

    /**
     *
     * @param {*} a
     * @param {*} b
     * @param {*} a1
     * @param {*} b1
     * @param {*} y
     */
    timestampInterpolating(a, b, a1, b1, y) {
        let x = (y - b1) * ((a1 - a) / (b1 - b)) + a1;
        return Math.floor(x);
    }
};

export default InterpolatingUtil;
